
/**
 * Created by Wojciech Szydlak on 14.01.2018.
 */

namespace Action.ContextMenu {
    enum SetGpsFor {
        client = 'SetClientGps',
        clientService = 'SetClientServiceGps'
    }

    export class MapSetGpsClient extends Action.UserActionBase {
        protected static setGpsFor = SetGpsFor;

        public execute(): void {
            return this.executeFor(
                MapSetGpsClient.setGpsFor.client,
                this.event.target.urlParams[URICenterParser.GET_PRAM_NAME_CLIENT_ID],
                ({lat, lng}) => {
                    let app = App.getInstance();
                    let clientId = this.event.target.urlParams[URICenterParser.GET_PRAM_NAME_CLIENT_ID];
                    let client = app.entityContainer.findClientById(clientId);
                    this.updateMarker(client, lat, lng);
                }
            );
        }

        protected executeFor(requestAction: SetGpsFor, id: string, callback: Function): void {
            let LatLng: google.maps.LatLng = this.event.params['latLng'] as google.maps.LatLng;
            let Geocode: Logic.Geocode = new Logic.Geocode();
            Geocode.getAddress(LatLng.lat(), LatLng.lng(), (address: string): void => {
                let lat: number = Logic.Util.shortenGPSComponent(LatLng.lat());
                let lng: number = Logic.Util.shortenGPSComponent(LatLng.lng());
                let requestSender: Logic.RequestSender = new Logic.RequestSender();
                requestSender.sendRequest(requestAction, {id, lat, lng}, (action: string, fields: Object, response: any): void => {
                    let alertType = requestSender.isError() ? Entity.View.AlertType.ERROR : Entity.View.AlertType.SUCCESS;
                    let alert = new Entity.View.Alert(alertType, requestSender.getMessage());
                    alert.show();
                    callback({lat, lng});
                });
            });
        }

        protected updateMarker(client: Entity.Map.Marker.Node.ClientNode, lat: number, lng: number): void {
            client.setPosition(new google.maps.LatLng(lat, lng));
            client.update();
            client.polylines.forEach(p => p.update());
        }
    }
}
